/* eslint-disable react/prop-types */
import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const customStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 47px;
  gap: 10px;
  height: 50px;
  border-radius: 48px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.16px;
  color: #ffffff;
  border: none;
  cursor: pointer;
`;

const CustomButton = styled.button`
  ${customStyles}
  background: ${(props) =>
    props.disabled
      ? 'grey'
      : 'linear-gradient(272.59deg, #53a8a0 0.78%, #449890 99.22%)'}
`;

const Button = (props) => {
  return (
    <CustomButton disabled={props.disabled} onClick={props.onClick}>
      {props.children}
    </CustomButton>
  );
};

Button.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Button;
